import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ebooks } from '../mock';
import { useCart } from '../context/CartContext';
import { Check, ShoppingCart, Dumbbell, Calendar, BookOpen, Video } from 'lucide-react';
import { toast } from 'sonner';

const Home = () => {
  const { addToCart } = useCart();
  const [email, setEmail] = useState('');

  const handleAddToCart = (ebook) => {
    const added = addToCart(ebook);
    if (added) {
      toast.success(`${ebook.title} adicionado ao carrinho!`);
    } else {
      toast.info('Este e-book já está no carrinho');
    }
  };

  const handleNewsletterSubmit = (e) => {
    e.preventDefault();
    if (email) {
      // Mock: salva email no localStorage
      const emails = JSON.parse(localStorage.getItem('newsletter_emails') || '[]');
      emails.push({ email, date: new Date().toISOString() });
      localStorage.setItem('newsletter_emails', JSON.stringify(emails));
      toast.success('Email cadastrado com sucesso!');
      setEmail('');
    }
  };

  return (
    <div style={{ background: 'var(--bg-page)', minHeight: '100vh', paddingTop: '100px' }}>
      {/* Hero Section */}
      <section style={{
        backgroundImage: `linear-gradient(rgba(0, 69, 52, 0.85), rgba(0, 69, 52, 0.85)), url('https://images.unsplash.com/photo-1534258936925-c58bed479fcb')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        padding: '80px 24px',
        textAlign: 'center',
        color: 'white'
      }}>
        <div className="container">
          <h1 className="display-large" style={{ color: 'white', marginBottom: '24px' }}>
            Transforme Seu Corpo em 4 Semanas
          </h1>
          <p className="body-large" style={{ color: 'rgba(255,255,255,0.9)', marginBottom: '32px', maxWidth: '700px', margin: '0 auto 32px' }}>
            Programas profissionais de hipertrofia com treinos detalhados, dieta ajustada e vídeos explicativos. Resultados garantidos!
          </p>
          <div style={{ display: 'flex', gap: '16px', justifyContent: 'center', flexWrap: 'wrap' }}>
            <Link to="/produtos">
              <button className="btn-primary">Ver Programas</button>
            </Link>
            <a href="#beneficios">
              <button className="btn-secondary" style={{ borderColor: 'white', color: 'white' }}>Saiba Mais</button>
            </a>
          </div>
        </div>
      </section>

      {/* Seção de Apresentação do Profissional */}
      <section style={{ padding: '64px 24px', background: 'var(--bg-card)' }}>
        <div className="container" style={{ maxWidth: '1200px' }}>
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
            gap: '48px',
            alignItems: 'center'
          }}>
            {/* Imagem do Profissional */}
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <img 
                src="https://customer-assets.emergentagent.com/job_fitness-ebooks/artifacts/7ij8yipi_image.png"
                alt="José Carlos Gallo - Personal Trainer"
                style={{
                  width: '100%',
                  maxWidth: '400px',
                  borderRadius: '24px',
                  boxShadow: '0 8px 32px rgba(27, 58, 95, 0.15)'
                }}
              />
            </div>

            {/* Texto de Credibilidade */}
            <div>
              <h2 className="heading-1" style={{ marginBottom: '24px' }}>
                Conheça José Carlos Gallo
              </h2>
              <p className="body-large" style={{ marginBottom: '24px' }}>
                Personal Trainer há mais de 36 anos, Fisiologista Clínico e do Exercício pela Universidade de Konl-Alemanha, 
                Professor de Educação Física, Fisioterapeuta e Nutricionista. Intitulado "Personal Trainer das estrelas", 
                com experiência em transformação corporal e treinamento de força, para homens e mulheres de 30 a 60 anos 
                que buscam resultados reais e duradouros de Saúde, Estética e Performance.
              </p>
              <p className="body-large" style={{ marginBottom: '24px' }}>
                Criador do <strong>Protocolo Anti-Reganho de Peso</strong> Pós Emagrecedores com Mounjaro, Ozempic e Wegovy. 
                Pós-graduação em Fisiologia do Exercício e Avaliação Corporal - UGF/RJ. Criador dos <strong>Métodos de 
                Treinamento Customizado</strong>, do <strong>Método de Emagrecimento P.E.S.O</strong> e do <strong>Método 
                Anti-Aging</strong>.
              </p>
              <div style={{ marginBottom: '16px' }}>
                <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px', marginBottom: '16px' }}>
                  <Check size={24} color="var(--brand-primary)" style={{ flexShrink: 0, marginTop: '2px' }} />
                  <p className="body-medium">
                    <strong>Certificações Profissionais</strong> em Treinamento de Força e Condicionamento Físico
                  </p>
                </div>
                <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px', marginBottom: '16px' }}>
                  <Check size={24} color="var(--brand-primary)" style={{ flexShrink: 0, marginTop: '2px' }} />
                  <p className="body-medium">
                    <strong>Especialista</strong> em Hipertrofia e Emagrecimento para público 30+
                  </p>
                </div>
                <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px', marginBottom: '16px' }}>
                  <Check size={24} color="var(--brand-primary)" style={{ flexShrink: 0, marginTop: '2px' }} />
                  <p className="body-medium">
                    <strong>Centenas de alunos transformados</strong> com programas personalizados e eficazes
                  </p>
                </div>
                <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
                  <Check size={24} color="var(--brand-primary)" style={{ flexShrink: 0, marginTop: '2px' }} />
                  <p className="body-medium">
                    <strong>Metodologia comprovada</strong> baseada em ciência e resultados práticos
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Benefícios */}
      <section id="beneficios" style={{ padding: '64px 24px' }}>
        <div className="container">
          <h2 className="heading-1" style={{ textAlign: 'center', marginBottom: '48px' }}>
            O Que Você Vai Receber
          </h2>
          <div className="network-grid">
            <div className="network-card" style={{ display: 'flex', gap: '24px', alignItems: 'center', flexWrap: 'wrap' }}>
              <div style={{ 
                flex: '0 0 280px',
                height: '280px', 
                overflow: 'hidden',
                borderRadius: '16px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                background: '#f5f5f5'
              }}>
                <img 
                  src="https://customer-assets.emergentagent.com/job_fitness-ebooks/artifacts/ebj9qs9q_DIVIS%C3%83O%20DE%20TREINOS.jpg" 
                  alt="Divisão de treinos"
                  style={{ 
                    width: '100%',
                    height: '100%',
                    objectFit: 'contain',
                    objectPosition: 'center'
                  }}
                />
              </div>
              <div style={{ flex: '1', minWidth: '250px' }}>
                <h3 className="network-card-title">Treinos Estruturados</h3>
                <p className="network-card-content">
                  Séries A, B, C, D, E divididas por grupamento muscular. 6-7 dias por semana com 6 exercícios detalhados por dia.
                </p>
              </div>
            </div>

            <div className="network-card" style={{ display: 'flex', gap: '24px', alignItems: 'center', flexWrap: 'wrap' }}>
              <div style={{ 
                flex: '0 0 280px',
                height: '280px', 
                overflow: 'hidden',
                borderRadius: '16px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                background: '#f5f5f5'
              }}>
                <img 
                  src="https://customer-assets.emergentagent.com/job_fitness-ebooks/artifacts/idiris6d_Modelo%20de%20card%C3%A1pio.png" 
                  alt="Modelo de cardápio"
                  style={{ 
                    width: '100%',
                    height: '100%',
                    objectFit: 'contain',
                    objectPosition: 'center'
                  }}
                />
              </div>
              <div style={{ flex: '1', minWidth: '250px' }}>
                <h3 className="network-card-title">Dieta e Suplementação</h3>
                <p className="network-card-content">
                  Plano alimentar ajustado com receitas práticas e imagens dos pratos. Guia completo de suplementação.
                </p>
              </div>
            </div>

            <div className="network-card" style={{ display: 'flex', gap: '24px', alignItems: 'center', flexWrap: 'wrap' }}>
              <div style={{ 
                flex: '0 0 280px',
                height: '280px', 
                overflow: 'hidden',
                borderRadius: '16px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                background: '#f5f5f5'
              }}>
                <img 
                  src="https://customer-assets.emergentagent.com/job_fitness-ebooks/artifacts/xxaj48dm_Remada%20baixa%20no%20cabo.jpg" 
                  alt="Exemplo de exercício"
                  style={{ 
                    width: '100%',
                    height: '100%',
                    objectFit: 'contain',
                    objectPosition: 'center'
                  }}
                />
              </div>
              <div style={{ flex: '1', minWidth: '250px' }}>
                <h3 className="network-card-title">Imagens Detalhadas</h3>
                <p className="network-card-content">
                  Imagens com descrição de como executar os exercícios, com o número de séries, repetições e carga ajustada para cada exercício.
                </p>
              </div>
            </div>

            <div className="network-card" style={{ display: 'flex', gap: '24px', alignItems: 'center', flexWrap: 'wrap' }}>
              <div style={{ 
                flex: '0 0 280px',
                height: '280px', 
                overflow: 'hidden',
                borderRadius: '16px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                background: '#f5f5f5'
              }}>
                <img 
                  src="https://customer-assets.emergentagent.com/job_fitness-ebooks/artifacts/86fhf7n9_Imagem1.jpg" 
                  alt="Programa de 4 semanas"
                  style={{ 
                    width: '100%',
                    height: '100%',
                    objectFit: 'contain',
                    objectPosition: 'center'
                  }}
                />
              </div>
              <div style={{ flex: '1', minWidth: '250px' }}>
                <h3 className="network-card-title">Programa de 4 Semanas</h3>
                <p className="network-card-content">
                  Periodização completa com progressão de carga. Resultados visíveis em apenas 28 dias.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Produtos em Destaque */}
      <section style={{ padding: '64px 24px', background: 'var(--bg-subtle)' }}>
        <div className="container">
          <h2 className="heading-1" style={{ textAlign: 'center', marginBottom: '48px' }}>
            Nossos Programas
          </h2>
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))',
            gap: '32px',
            maxWidth: '1200px',
            margin: '0 auto'
          }}>
            {ebooks.map(ebook => (
              <div key={ebook.id} className="network-card" style={{ padding: '0', overflow: 'hidden' }}>
                <img 
                  src={ebook.image} 
                  alt={ebook.title}
                  style={{ width: '100%', height: '250px', objectFit: 'cover' }}
                />
                <div style={{ padding: '24px' }}>
                  <p className="caption" style={{ color: 'var(--brand-dark)', fontWeight: '600', marginBottom: '8px' }}>
                    {ebook.target}
                  </p>
                  <h3 className="heading-3" style={{ marginBottom: '12px' }}>
                    {ebook.title}
                  </h3>
                  <p className="body-medium" style={{ marginBottom: '16px' }}>
                    {ebook.description}
                  </p>
                  <div style={{ marginBottom: '16px' }}>
                    {ebook.features.slice(0, 3).map((feature, idx) => (
                      <div key={idx} style={{ display: 'flex', gap: '8px', marginBottom: '8px', alignItems: 'flex-start' }}>
                        <Check size={18} color="var(--brand-dark)" style={{ flexShrink: 0, marginTop: '2px' }} />
                        <span className="body-small">{feature}</span>
                      </div>
                    ))}
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '24px' }}>
                    <div>
                      <p className="caption" style={{ marginBottom: '4px' }}>Apenas</p>
                      <p className="heading-2" style={{ color: 'var(--brand-dark)' }}>
                        R$ {ebook.price.toFixed(2)}
                      </p>
                    </div>
                    <button 
                      className="btn-primary"
                      onClick={() => handleAddToCart(ebook)}
                      style={{ display: 'flex', alignItems: 'center', gap: '8px' }}
                    >
                      <ShoppingCart size={18} />
                      Comprar
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Newsletter */}
      <section style={{ padding: '64px 24px' }}>
        <div className="container">
          <div className="network-card" style={{ 
            maxWidth: '700px', 
            margin: '0 auto', 
            textAlign: 'center',
            padding: '48px 32px'
          }}>
            <h2 className="heading-2" style={{ marginBottom: '16px' }}>
              Receba Dicas Exclusivas
            </h2>
            <p className="body-medium" style={{ marginBottom: '24px' }}>
              Cadastre seu email e receba gratuitamente dicas de treino, nutrição e promoções especiais.
            </p>
            <form onSubmit={handleNewsletterSubmit} style={{ 
              display: 'flex', 
              gap: '12px',
              maxWidth: '500px',
              margin: '0 auto',
              flexWrap: 'wrap'
            }}>
              <input
                type="email"
                placeholder="Seu melhor email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                style={{
                  flex: '1',
                  minWidth: '250px',
                  padding: '14px 20px',
                  borderRadius: '25px',
                  border: '2px solid var(--border-medium)',
                  fontSize: '16px',
                  outline: 'none'
                }}
              />
              <button type="submit" className="btn-primary">
                Cadastrar
              </button>
            </form>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;